import { makeStyles } from "@material-ui/core/styles";

const buttonStyle = makeStyles((theme) => ({
    button: {
        backgroundColor: "#29438D",
        height: 40,
        minWidth: 120,
        // width: 120,
        color: "#FFF",
        "&:hover": {
            backgroundColor: "#142B6B"
        }
    },

    disabledButton: {
        backgroundColor: "#29438D",
        height: 40,
        minWidth: 120,
        color: "#FFF",
        opacity: "60%",
        "&:hover": {
            backgroundColor: "#142B6B"
        }
    },
    clearButton: {
        backgroundColor: "#4E6DF0",
        height: 40,
        width: 120,
        color: "#FFF",
        "&:hover": {
            backgroundColor: "#3e5dde"
        }
    },
    blockButton: {
        backgroundColor: "#D93C5A",
        height: 40,
        width: 120,
        color: "#FFF",
        "&:hover": {
            backgroundColor: "#bd2a46"
        }
    },
    gridButton: {
        backgroundColor: "#29438D",
        color: "#FFF",
        width: "100%",
        "&:hover": {
            backgroundColor: "#142B6B"
        }
    },
    releaseButton: {
        backgroundColor: "#37AF57",
        height: 40,
        width: 120,
        color: "#FFF",
        "&:hover": {
            backgroundColor: "#27a348"
        }
    },
    successButton: {
        backgroundColor: "#e2f2e2",
        color: "#5cb85c",
        fill: "#5cb85c",
        width: "100%",
        "&:hover": {
            backgroundColor: "#b4e0b4"
        }
    },
    errorButton: {
        backgroundColor: "#ecb6b6",
        color: "#f44336",
        fill: "#f44336",
        width: "100%",
        "&:hover": {
            backgroundColor: "#e09494"
        }
    },
    addButton: {
        backgroundColor: "#29438D",
        color: "#ffffff",
        fill: "#f44336",
        width: "100%",
        "&:hover": {
            backgroundColor: "#1D2F6D"
        }
    },
    disabledAddButton: {
        backgroundColor: "#29438D",
        color: "#ffffff",
        fill: "#f44336",
        opacity: "60%",
        width: "100%",
        "&:hover": {
            backgroundColor: "#1D2F6D"
        }
    },
    deterioratedButton: {
        backgroundColor: "#e68728",
        color: "#fff",
        fill: "#fff",
        width: "100%",
        "&:hover": {
            backgroundColor: "#e87e15"
        }
    },
    print: {
        backgroundColor: "#fff",
        paddingRight: 20,
        paddingLeft: 20,
        color: "#29438D",
        fill: "#29438D",
        border: "1px solid #29438D",
        "&:hover": {
            backgroundColor: "#a7b3d4"
        }
    },
    buttonWithoutSize: {
        backgroundColor: "#29438D",
        color: "#FFF",
        "&:hover": {
            backgroundColor: "#142B6B"
        }
    },
    lightExtendedButton: {
        backgroundColor: "#4E6DF0",
        height: 40,
        width: 220,
        color: "#FFF",
        "&:hover": {
            backgroundColor: "#3e5dde"
        }
    },
    lightExtendedButtonWithoutWidth: {
        backgroundColor: "#4E6DF0",
        height: 40,
        color: "#FFF",
        "&:hover": {
            backgroundColor: "#3e5dde"
        }
    },
    cianoButton: {
        backgroundColor: "#00bcd4",
        color: "#fff",
        fill: "#fff",
        height: 40,
        minWidth: 140,
        //  width: "100%",
        "&:hover": {
            backgroundColor: "#00bcd4"
        }
    },
    blackButton: {
        backgroundColor: "#2e2e2e",
        color: "#fff",
        fill: "#fff",
        width: "100%",
        "&:hover": {
            backgroundColor: "#2e2e2e"
        }
    },
    blackButtonDisabled: {
        backgroundColor: "#2e2e2e",
        color: "#fff",
        fill: "#fff",
        width: "100%",
        "&:hover": {
            backgroundColor: "#2e2e2e"
        },
        opacity: 0.7,
        cursor: "not-allowed"
    },
    redButton: {
        backgroundColor: "#ff3547",
        color: "#fff",
        fill: "#fff",
        height: 40,
        width: 120,
        "&:hover": {
            backgroundColor: "#ff3547"
        }
    },
    externalAppicationXDeviceProgram: {
        backgroundColor: "#e0ebee",
        color: "#FFF",
        width: "100%",
        "&:hover": {
            backgroundColor: "#c9d3d6",
        },
    },
}));

export default buttonStyle;
